import {PLATFORM, DOM} from 'aurelia-framework';
import {RouteConfig} from 'aurelia-router';
import {instance} from './di';
import {I18N} from 'aurelia-i18n';

export function indexOfNode(node: Element) {
  let index = 0;

  while (node = node.previousElementSibling) {
    index++;
  }

  return index;
}

export function isChildOf(parent: Node, child: Node) {
  while (child = child.parentNode) {
    if (child === parent) {
      return true;
    }
  }

  return false;
}

export function equalsOrChildOf(parent: Node, child: Node) {
  return parent === child || isChildOf(parent, child);
}

/**
 * @decription : set an element in the middle of the window
 */
export function windowCentered(element?: HTMLElement) {
  if (element) {
    const elDimensions = element.getBoundingClientRect();
    const elWidth = elDimensions.width;
    const elHeight = elDimensions.height;
    const horizontalMidline = PLATFORM.global.innerWidth / 2;
    const verticalMidline = PLATFORM.global.innerHeight / 2;

    element.style.left = horizontalMidline - elWidth / 2 + "px";
    element.style.top = verticalMidline - elHeight / 2 + "px";
  }
}
/**
 * @decription : set the view meta data description and keyword
 */
export function setViewMetaData(routeMap: RouteConfig) {
  const i18n = instance(I18N);
  let metadescription: HTMLMetaElement = DOM.querySelectorAll('head meta[name=description]')[0] as any;
  let metakeywords: HTMLMetaElement = DOM.querySelectorAll('head meta[name=keywords]')[0] as any;
  if(routeMap && routeMap.settings && routeMap.settings.description) {
    if( metadescription ){
      metadescription.content = i18n.tr(routeMap.settings.description);
    } else {
      metadescription = DOM.createElement('meta') as any;
      metadescription.name = 'description';
      metadescription.content = i18n.tr(routeMap.settings.description);
      (DOM.querySelectorAll('head') as any).appendNode(metadescription);
    }
    if( metakeywords ){
      metakeywords.content = i18n.tr(routeMap.settings.keywords);
    } else {
      metakeywords = DOM.createElement('meta') as any;
      metakeywords.name = 'keywords';
      metakeywords.content = i18n.tr(routeMap.settings.description);
      DOM.querySelectorAll('head')[0].appendChild(metakeywords);
    }
  }
}
